import { render, staticRenderFns } from "./InventoryTableMobile.vue?vue&type=template&id=0ce3da12&scoped=true"
import script from "./InventoryTableMobile.vue?vue&type=script&lang=js"
export * from "./InventoryTableMobile.vue?vue&type=script&lang=js"
import style0 from "./InventoryTableMobile.vue?vue&type=style&index=0&id=0ce3da12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce3da12",
  null
  
)

export default component.exports